<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import { blownInsulation, drywall, screed } from '@/actions/App/Http/Controllers/ServiceController'

const posts = [
    {
        id: 1,
        title: 'Montáže sádrokartonu',
        href: drywall.url(),
        imageUrl: '/src/services/montaze-sadrokartonu-ukazka.webp',
    },
    {
        id: 2,
        title: 'Betonové stěrky',
        href: screed.url(),
        imageUrl: '/src/services/betonova-sterka-ukazka.webp',
    },
]
</script>

<template>
    <AppLayout
        meta_title="Foukaná izolace Olomouc - úspora energie a tepla"
        meta_description="Foukaná izolace stropů a podkroví - rychlá aplikace, výrazná úspora energie. Olomouc a široké okolí. Zjistěte více."
        :meta_canonical="blownInsulation.url()"
    >
        <template #content>
            <section class="section-width mt-16">
                <header class="max-w-4xl">
                    <h1 class="header-h">Foukaná izolace Olomouc</h1>
                    <p class="mt-6 text-xl/8 text-balance text-gray-700">
                        Foukaná izolace stropů a podkroví - rychlá aplikace, výrazná úspora energie. Olomouc a široké
                        okolí.
                    </p>
                </header>

                <section
                    class="relative -top-32 mt-20 grid grid-cols-1 overflow-hidden pt-32 lg:grid-cols-2 lg:gap-x-8 lg:gap-y-8"
                >
                    <div class="lg:pr-8">
                        <h2 class="text-2xl font-semibold tracking-tight text-pretty text-gray-900">
                            Jak probíhá provedení foukané izolace
                        </h2>
                        <p class="mt-6 text-base/7 text-gray-600">
                            Foukaná izolace je moderní způsob zateplení stropů, podkroví nebo dutých konstrukcí. Výhodou
                            je rychlá aplikace bez nutnosti složité stavební přípravy a možnost vyplnit i těžko
                            přístupná místa.
                        </p>

                        <div class="mt-8 space-y-6">
                            <div>
                                <h3 class="text-lg font-semibold text-gray-900">1. Příprava místa</h3>
                                <ul class="mt-2 list-disc space-y-1 pl-5 text-sm/6 text-gray-600">
                                    <li>Nejprve se zkontroluje stav konstrukce (např. stropu nebo půdy).</li>
                                    <li>
                                        Odstraní se nečistoty a připraví se otvory nebo prostupy, kudy se izolace bude
                                        foukat.
                                    </li>
                                    <li>
                                        Určí se typ a množství izolace podle požadované tloušťky a vlastností (celulóza,
                                        minerální vata, polystyrenové granule).
                                    </li>
                                </ul>
                            </div>

                            <div>
                                <h3 class="text-lg font-semibold text-gray-900">2. Doprava materiálu</h3>
                                <ul class="mt-2 list-disc space-y-1 pl-5 text-sm/6 text-gray-600">
                                    <li>Izolační materiál je přivezen v pytlích nebo balících.</li>
                                    <li>
                                        Speciální stroj (Tajfun) materiál nadrtí a pomocí hadice dopraví na místo
                                        aplikace.
                                    </li>
                                </ul>
                            </div>

                            <div>
                                <h3 class="text-lg font-semibold text-gray-900">3. Aplikace izolace</h3>
                                <ul class="mt-2 list-disc space-y-1 pl-5 text-sm/6 text-gray-600">
                                    <li>
                                        Izolace se hadicí fouká do prostoru – například na podlahu půdy, do dutých stěn
                                        nebo šikmin střechy.
                                    </li>
                                    <li>
                                        Materiál vyplní všechny mezery a vytvoří souvislou izolační vrstvu bez spár.
                                    </li>
                                    <li>Tloušťka izolace se hlídá podle předem vypočítaných hodnot.</li>
                                </ul>
                            </div>

                            <div>
                                <h3 class="text-lg font-semibold text-gray-900">4. Dokončení prací</h3>
                                <ul class="mt-2 list-disc space-y-1 pl-5 text-sm/6 text-gray-600">
                                    <li>Uzavřou se prostupy nebo otvory, kudy byla izolace vháněna.</li>
                                    <li>Provádí se vizuální kontrola rovnoměrnosti a množství.</li>
                                    <li>
                                        Pracoviště se uklidí – aplikace je čistá a rychlá, většinou trvá jen několik
                                        hodin.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div
                        class="mt-4 flex flex-col justify-center gap-8 sm:justify-end sm:pl-20 md:flex-row lg:-mt-40 lg:pl-0"
                    >
                        <div
                            class="mx-auto w-72 flex-none space-y-8 pt-32 sm:ml-0 sm:pt-80 lg:w-50 lg:pt-36 xl:w-72 xl:pt-80"
                        >
                            <div class="relative">
                                <img
                                    alt="Foukana izolace Olomouc"
                                    src="/src/services/foukana_1.webp"
                                    class="aspect-square w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                                />
                                <div
                                    class="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-gray-900/10 ring-inset"
                                />
                            </div>
                        </div>
                        <div class="mx-auto w-72 flex-none space-y-8 sm:pt-52 lg:w-50 lg:pt-36 xl:w-72">
                            <div class="relative">
                                <img
                                    alt="Foukana izolace Olomouc a okolí"
                                    src="/src/services/foukana_2.webp"
                                    class="aspect-square w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                                />
                                <div
                                    class="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-gray-900/10 ring-inset"
                                />
                            </div>
                            <div class="relative">
                                <img
                                    alt="Foukana izolace Supafil Olomouc"
                                    src="/src/services/foukana_3.webp"
                                    class="aspect-square w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                                />
                                <div
                                    class="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-gray-900/10 ring-inset"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="mt-10 lg:col-span-1 lg:mt-0">
                        <p class="text-base/7 font-semibold text-gray-500">Provádíme</p>
                        <hr class="my-2 border-t border-gray-200" />
                        <ul class="grid list-inside list-disc grid-cols-1 gap-y-4">
                            <li class="text-sm/6 text-gray-600">
                                Nejvíce oceňovanou vlastností foukané izolace je její schopnost dokonale zaplnit všechny
                                dutiny. Vzniká tak 100% izolační vrstva bez jakýchkoliv tepelných mostů.
                            </li>
                            <li class="text-sm/6 text-gray-600">
                                Foukaná izolace je dokonale prodyšná a vodoodpudivá. Přispívá k vytváření zdravého
                                prostředí v domácnosti a je odolná vůči plísním a hnilobám.
                            </li>
                            <li class="text-sm/6 text-gray-600">
                                Foukaná izolace je levná a velice účinná. Návratnost investice je obvykle do 5 let.
                            </li>
                            <li class="text-sm/6 text-gray-600">
                                Minerální vata používaná na foukanou izolaci je nehořlavá a začíná se tavit až při
                                2000°C, což zvyšuje požární bezpečnost objektu.
                            </li>
                            <li class="text-sm/6 text-gray-600">
                                Při aplikaci nevzniká žádný prořez - platíte jen za skutečně využitý materiál a nemusíte
                                řešit likvidaci odpadu.
                            </li>
                        </ul>
                    </div>

                    <div class="mt-10 lg:col-span-1 lg:mt-0">
                        <p class="text-base/7 font-semibold text-gray-500">Nástroje a příslušentví</p>
                        <hr class="my-2 border-t border-gray-200" />
                        <ul class="grid list-inside list-disc grid-cols-1 gap-y-4">
                            <li class="text-sm/6 text-gray-600">sádrokartonové desky</li>
                            <li class="text-sm/6 text-gray-600">profilové plechy</li>
                            <li class="text-sm/6 text-gray-600">montážní materiál</li>
                            <li class="text-sm/6 text-gray-600">izolační materiály</li>
                            <li class="text-sm/6 text-gray-600">nástroje pro montáž</li>
                        </ul>
                    </div>

                    <div class="col-span-full mt-10">
                        <div class="mx-auto max-w-2xl text-center">
                            <h2 class="header-h text-center">Další služby</h2>
                        </div>
                        <div
                            class="bg-brand-orange mx-auto mt-5 grid max-w-2xl grid-cols-1 gap-5 rounded-4xl p-4 lg:mx-0 lg:max-w-none lg:grid-cols-2"
                        >
                            <article
                                v-for="post in posts"
                                :key="post.id"
                                class="relative flex flex-col items-start justify-between"
                            >
                                <div class="relative w-full">
                                    <img
                                        :src="post.imageUrl"
                                        alt=""
                                        class="aspect-video w-full rounded-2xl bg-gray-100 object-cover sm:aspect-2/1 lg:aspect-3/2"
                                    />
                                    <div class="absolute inset-0 rounded-2xl inset-ring inset-ring-gray-900/10" />
                                </div>

                                <div class="flex w-full justify-center">
                                    <h3
                                        class="font-chivo mt-3 text-xl font-semibold tracking-tight text-white sm:text-3xl"
                                    >
                                        {{ post.title }}
                                    </h3>
                                </div>

                                <Link
                                    :href="post.href"
                                    class="absolute inset-0"
                                />
                            </article>
                        </div>
                    </div>
                </section>
            </section>
        </template>
    </AppLayout>
</template>
